/* eslint-disable */
/* tslint:disable */

/** getHublerInstitutionsAwaitingFeedback
 * method: get
 * summary: Get hubler institutions awaiting feedback
 */

import type {
  GetHublerInstitutionsAwaitingFeedbackResponseDto,
  BadRequestResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/institutions/awaiting-feedback`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/institutions/awaiting-feedback`

export type GetHublerInstitutionsAwaitingFeedbackSuccess =
  GetHublerInstitutionsAwaitingFeedbackResponseDto
export type GetHublerInstitutionsAwaitingFeedbackError =
  | BadRequestResponseDto
  | ApiResponseDto
